import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Star } from 'lucide-react';
import './ProductDetail.css';
import CommentList from "@pages/client/CommentList/CommentList";
import ReviewModal from '@pages/client/ReviewModal/ReviewModal';


const ProductDetail = () => {
    const navigate = useNavigate();

    const location = useLocation();

    const dataFromCatalog = location.state;

    const [showModal, setShowModal] = useState(false);


    const [userRating] = useState(0);

    const product = {
        id: dataFromCatalog?.id || 'Id',
        name: dataFromCatalog?.name || 'Nombre',
        price: dataFromCatalog?.price || 'Precio',
        rating: dataFromCatalog?.rating || 'Clasificación',
        reviews: dataFromCatalog?.reviews || 'Vistas',
        description: dataFromCatalog?.description || 'Dsecripción',
        image: dataFromCatalog?.image || 'No hay imagen'
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, i) => (
            <Star
                key={i}
                size={22}
                fill={i < rating ? '#FFB84D' : 'none'}
                color={i < rating ? '#FFB84D' : '#ccc'}
                strokeWidth={1.5}
                
            />
        ));
    };

    const getMonthAbbr = () => {
        const meses = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.',
                       'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'];
        return meses[new Date().getMonth()];
    };

    return (
        <div className="detail-container">

            {/* Header con imagen */}
            <div className="detail-header">
                <img
                    src={product.image}
                    alt={product.name}
                    className="main-img"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/400x400?text=Sin+Imagen';
                    }}
                />

                {/* Botón regresar flotante */}
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} color="#3B2A25" strokeWidth={2.5} />
                </button>

                {/* Corazón flotante */}
                <button className="fav-btn">
                    <Heart size={20} color="#E85D5D" fill="#E85D5D" strokeWidth={0} />
                </button>
            </div>

            {/* Tarjeta de info */}
            <div className="detail-info">
                <h1>{product.name}</h1>

                <div className="stars-row">
                    {renderStars(product.rating)}
                    <span className="reviews-count">({product.reviews} opiniones)</span>
                </div>

                <span className="price-tag">
                    $ {Number(product.price).toLocaleString('es-AR')}
                </span>

                <p className="description">{product.description}</p>

                <hr />
                
                {/* Calificacion de producto */}
                <h3 className="rating-title">¿Qué te pareció?</h3>
                    <div className="rating-input" onClick={() => setShowModal(true)}>
                        <div className="stars-with-date">
                            {renderStars(userRating, true)}
                            <span className="month-abbr">{getMonthAbbr()}</span>
                        </div>
                        <span className="date-input">Toca para calificar →</span>
                    </div>
                <CommentList productId={product.id} />

                <div className="sticky-footer">
                <span className="footer-price">
                    $ {Number(product.price).toLocaleString('es-AR')}
                </span>
                    <button className="ar-button" onClick={() => navigate('/ruta2')}>
                        <span>✨</span> Ver en tu mesa
                    </button>
                </div>
            </div>

            {/* Modal flotante */}
            {showModal && (
                <ReviewModal
                    productId={product.id}
                    onClose={() => setShowModal(false)}
                />
            )}


        </div>
    );
};

export default ProductDetail;
